export enum $auditedDocument {
  _id = '_id',
  reference = 'reference',
  referenceHash = 'referenceHash',
  scanId = 'scanId',
  size = 'size',
  type = 'type',
  title = 'title',
  version = 'version',
  screenshot = 'screenshot',
  pageId = 'pageId',
  mobileScreenId = 'mobileScreenId',
  scanPoint = 'scanPoint',
  createdAt = 'createdAt',
  tenantId = 'tenantId',
}

export enum AuditDocumentQuery {
  url = 'url',
  pageId = 'pageId',
}

export enum DuplicateReferenceResolver {
  NONE = 'NONE', // do not resolve
  UUID = 'UUID', // {reference}/duplicate/{uuid}
  NUMBER = 'NUMBER', // {reference} ({number})
}
